import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../share/service/auth.service";
import { AlertService } from "../../share/service/alert.service";
import { UserDataService } from "src/app/share/data-service/user.data.service";
import { LoadingService } from "src/app/share/service/loading.service";
import { Router } from "@angular/router";
import { PermissionService } from "src/app/share/service/permission.service";
import { PRODUCT_TRANSACTIONS, PRODUCT_QUOTATIONS } from "src/app/share/constants/access.constants";
import { TranslateService } from "@ngx-translate/core";
import { catchError, finalize, tap, throwError } from "rxjs";
import { PartnerService } from "src/app/share/service/partner.service";

@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	hide: boolean = true;
	formGroup: UntypedFormGroup;
	partnerCode: string = "";
	bannerLink: string = "https://storage.googleapis.com/ps-asset/digi_rep/hero/dr-bg.png";
	forgotPasswordLink: string = "/forgot-password";

	constructor(
		private router: Router,
		private authService: AuthService,
		private userDataService: UserDataService,
		private loadingService: LoadingService,
		private translate: TranslateService,
		private permissionService: PermissionService,
		private alertService: AlertService,
		private partnerService: PartnerService,
	) {
		/* Handle for Partners */
		this.partnerCode = this.partnerService.getPartnerCode();

		if(!this.partnerCode) {
			this.partnerCode = "ps";
		} 
		this.getPartnerInfo(this.partnerCode);

		if (this.partnerCode?.length) {
			localStorage.removeItem("partner");
		}

		if (authService.isLoggedIn()) {
			location.href = "/transactions";
		}
	}

	ngOnInit(): void {
		this.formGroup = new UntypedFormGroup({
			email: new UntypedFormControl(null, [Validators.required, Validators.email]),
			password: new UntypedFormControl(null, [Validators.required]),
		});
	}

	login() {
		if (this.formGroup.invalid) return;
		let value = this.formGroup.value;
		this.loadingService.loadingOn(true);

		this.userDataService.login(value.email, value.password)
			.pipe(
				catchError((err) => {
					this.alertService.openSnackBar(err.error);
					return throwError(err);
				}),	
				tap((x) => {
					let decodedToken = this.authService.decodeToken(x);
					if(decodedToken.IsActive == 'False'){
						this.alertService.openSnackBar(this.translate.instant('error.userDeactivated'));
						return;
					}

					this.authService.setToken(x);
					if (this.partnerCode.length) localStorage.setItem("partner", this.partnerCode);
					this.redirectToPage();
				}),
				finalize(() => this.loadingService.loadingOff(true))
			).subscribe();
	}

	private redirectToPage() {
		let transactionsAllowed = this.permissionService.getProductAccess(PRODUCT_TRANSACTIONS);
		let quotationsAllowed = this.permissionService.getProductAccess(PRODUCT_QUOTATIONS);

		if(transactionsAllowed){
			location.href = "/transactions";
		} else if (quotationsAllowed){
			location.href = "/quotations";
		}
	}

	private getPartnerInfo(partnerCode) {
		if(partnerCode && partnerCode != 'ps') {
			this.bannerLink = `https://storage.googleapis.com/ps-asset/digi_rep/hero/dr_${partnerCode}-bg.png`
			this.forgotPasswordLink = `/forgot-password?partnerCode=${partnerCode}`;
		}
	}

	goToForgotPass() {
		if(this.partnerCode && this.partnerCode != 'ps') {
			window.location.href = "/forgot-password?partnerCode=" + this.partnerCode;
		} else {
			window.location.href = "/forgot-password";
		}
	}
}